import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { SharedHttp } from "../../../services/http-client.service";
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { ComponentService } from "../../../services/component.service";
import { InitiateDcaComponent } from "../initiate-dca/initiate-dca.component";
import { DeactivateDcaComponent } from "../deactivate-dca/deactivate-dca.component";
import { AuthenticationWalletModalComponent } from "../authentication-wallet-modal/authentication-wallet-modal.component";
import { Router } from "@angular/router";
import { PaymentInstructionsWalletModalComponent } from "../payment-instructions-wallet-modal/payment-instructions-wallet-modal.component";
import { BankaccountWhitelistInfoComponent } from "../bankaccount-whitelist-info/bankaccount-whitelist-info.component";
import { WalletDocumentExpirationModalComponent } from "../wallet-document-expiration-modal/wallet-document-expiration-modal.component";
import { ResetMfaMessageModalComponent } from "../reset-mfa-message-modal/reset-mfa-message-modal.component";
let RecurringOrdersComponent = class RecurringOrdersComponent {
    constructor(sanitizer, themeService, httpClient, compService, router) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.httpClient = httpClient;
        this.compService = compService;
        this.router = router;
        this.borderRadiusLarger = '';
        this.defaultCurrency = localStorage.getItem('defaultCurrency');
        this.dcaLoaded = false;
        this.dcas = [];
        this.dcaStatusActive = 'ACTIVE';
        this.bankAccounts = [];
        this.bankAccountsApproved = [];
        this.statusApproved = 'APPROVED';
        this.waitingForApprovalStatus = 'WAITING_FOR_APPROVAL';
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    ngOnInit() {
        this.user = JSON.parse(localStorage.getItem('user'));
        if (!this.user || this.user.is_company_user || !this.user.eligible_for_wallet ||
            (!this.user.personally_validated && this.user.user_type_id.type !== 'lite_verified') || this.user.api_mfa_enabled != 1) {
            this.router.navigateByUrl('');
        }
        this.getDcas();
        this.getCurrencies();
        this.getWallets();
        this.getBankAccounts();
    }
    getDcas() {
        this.httpClient.get('dca/getdcas').subscribe((data) => {
            this.dcaLoaded = true;
            this.dcas = data['dcas'];
        });
    }
    getWallets() {
        this.httpClient.get('wallet/getwallets').subscribe((data) => {
            this.fiatWallet = data['wallets'].find(wallet => wallet.wallet.currency.fiat === true);
        });
    }
    showPaymentInstructions(dca) {
        this.httpClient.get('wallet/getfiatdepositpaymentdetails?customerWalletId=' + this.fiatWallet.wallet.verboseId + '&currency=' + this.fiatWallet.wallet.currency.verboseId).subscribe((data) => {
            const address = this.user.address ? (', ' + this.user.address) : '';
            const city = this.user.city ? (', ' + this.user.city) : '';
            const userDetails = this.user.name + address + city;
            const paymentDetails = {
                bankAccount: data['fiatDepositPaymentDetails']['bank_account'],
                paymentNumber: data['fiatDepositPaymentDetails']['payment_number'],
                paymentPurpose: data['fiatDepositPaymentDetails']['payment_purpose'],
                paymentModelCode: data['fiatDepositPaymentDetails']['payment_model_code'],
                currency: this.fiatWallet.wallet.currency.verboseId,
                amount: dca.amount
            };
            this.httpClient.post('wallet/getipsqrcode', { paymentDetails }).subscribe((ipsQRData) => {
                this.compService.openModal(PaymentInstructionsWalletModalComponent, {
                    userDetails,
                    merchDetails: ipsQRData['ipsQRData']['merchDetails'],
                    amount: dca.amount,
                    currency: this.fiatWallet.wallet.currency.verboseId,
                    paymentDetails: data['fiatDepositPaymentDetails'],
                    ipsQRCode: ipsQRData['ipsQRData']['ipsQR']['b64data']
                });
            });
        });
    }
    deactivateDca(id) {
        const userData = JSON.parse(localStorage.getItem('user'));
        if (userData.wallet_blocked) {
            this.compService.openModal(ResetMfaMessageModalComponent);
            return;
        }
        if (userData.block_transactions || userData.pending_for_document) {
            this.compService.openModal(WalletDocumentExpirationModalComponent);
            return;
        }
        this.compService.openModal(DeactivateDcaComponent, { dca_id: id }, () => {
            this.getDcas();
            this.compService.openModal(AuthenticationWalletModalComponent, {
                authenticated: true,
                type: 'deactivate_dca',
                isSuccess: true,
            });
        });
    }
    createNewDca() {
        const userData = JSON.parse(localStorage.getItem('user'));
        if (userData.wallet_blocked) {
            this.compService.openModal(ResetMfaMessageModalComponent);
            return;
        }
        if (userData.block_transactions || userData.pending_for_document) {
            this.compService.openModal(WalletDocumentExpirationModalComponent);
            return;
        }
        this.compService.openModal(InitiateDcaComponent, {
            currencies: this.currencies,
            path: 'wallet'
        }, (success) => {
            this.getDcas();
            this.compService.openModal(AuthenticationWalletModalComponent, {
                authenticated: true,
                type: 'dca',
                isSuccess: true,
            });
        });
    }
    getCurrencies() {
        this.httpClient.get('wallet/getallcurrencies').subscribe((data) => {
            this.currencies = data['currencies'].filter(currency => currency.fiat === false);
        });
    }
    downloadAnnex(dcaId) {
        this.httpClient.get('dca/' + dcaId + '/getdcadocument').subscribe((data) => {
            const file = data['document'];
            if (!(file === null || file === void 0 ? void 0 : file.download)) {
                return;
            }
            const a = document.createElement('a');
            a.href = file.download;
            a.download = file.name;
            document.body.appendChild(a);
            a.click();
            a.remove();
        });
    }
    getBankAccounts() {
        this.httpClient.get('user/getbankaccounts').subscribe((result) => {
            this.bankAccounts = result;
            this.bankAccountsApproved = this.bankAccounts.filter(bankAccount => bankAccount.status === this.statusApproved);
        });
    }
    addNewBankAccount() {
        this.compService.openModal(BankaccountWhitelistInfoComponent, {
            pendingProcess: this.bankAccounts.some(account => account.status === this.waitingForApprovalStatus),
        });
    }
};
RecurringOrdersComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: SharedHttp },
    { type: ComponentService },
    { type: Router }
];
RecurringOrdersComponent = __decorate([
    Component({
        selector: 'app-recurring-orders',
        template: __importDefault(require("./recurring-orders.component.html")).default,
    })
], RecurringOrdersComponent);
export { RecurringOrdersComponent };
